export default {
    trackXProps: {
        style: {
            left: '0',
            width: '100%',
            bottom: '-8px',
            overflow: 'visible',
            background: ''
        }
    },
    thumbXProps: {
        style: {
            width: '10px',
            height: '4px',
            background: '#BAC0CB'
        }
    },
    trackYProps: {
        style: {
            top: '0',
            height: '100%',
            right: '-20px',
            paddingBottom: '10px',
            overflow: 'visible',
            background: ''
        }
    },
    thumbYProps: {
        style: {
            width: '4px',
            background: '#BAC0CB'
        }
    }
}
